<style scoped>
	.dataTables_info {
		padding-left: 10px !important;
	}

	.p-t-30 {
		padding-top: 20px;
		padding-bottom: 20px;
		padding-left: 50px;
		padding-right: 50px;
	}
</style>
<template>
	<section class="section-container supplier-details" v-if="is_advanced || is_administrator || is_contractor">
		<div class="content-wrapper">

			<div class="content-heading" v-if="supplier_user.id">
				{{ $t('supplier.edit') }}
			</div>

			<div class="content-heading" v-else>
				<div class="container-fluid">
					<div class="row">
						<div class="col-md-6">{{$t('supplierinfo.title')}}</div>
						<div class="col-md-6 text-right">
							<a href="#" @click="cancelEdit()" class="btn btn-sm btn-secondary"
							   :title="$t('global.cancel')"
							   v-if="editMode">{{$t('supplier.cancel')}}
							</a>
							<a href="#" @click="toggleEditMode()" class="btn btn-sm"
							   :title="$t('supplier.confirm')"
							   :class="editButton.class" v-if="is_advanced || is_administrator">
								<i class="icon-note" v-if="!editMode"></i>
								{{editButton.label}}
							</a>
						</div>
					</div>
				</div>
			</div>
			<!-- Content -->
			<div class="row">
				<div class="col-xl-12">
					<div class="card">
						<div class="card-body">
							<div class="fields">
								<div class="row">
									<div class="col-md-12">
										<h4>{{supplier.name}}</h4>
									</div>
								</div>
								<div class="row">
									<div class="col-md-6" v-if="!editMode">
										<div class="row">
											<div class="col-md-4">
												<b>{{$t('supplierinfo.details.registration_code')}}</b>
											</div>
											<div class="col-md-6">{{supplier.registration_code}}</div>
										</div>
										<div class="row">
											<div class="col-md-4">
												<b>{{$t('supplierinfo.details.address')}}</b>
											</div>
											<div class="col-md-6">{{supplier.address}}</div>
										</div>
										<div class="row">
											<div class="col-md-4">
												<b>{{$t('supplierinfo.details.country')}}</b>
											</div>
											<div class="col-md-6">
												<span v-for="(country, idx) in countries" :key="idx"
													  v-if="country.code == supplier.country_code"> {{country
													.name}}</span></div>
										</div>
										<div class="row">
											<div class="col-md-4">
												<b>{{$t('supplierinfo.details.email')}}</b>
											</div>
											<div class="col-md-6">{{supplier.email}}</div>
										</div>
										<div class="row" v-if="is_administrator || is_contractor">
											<div class="col-md-4">
												<b>{{$t('make.groups')}}</b>
											</div>
											<div class="col-md-6">
												<span class="text-green" v-for="(group,idx) in groups" :key="idx">
													{{group.name}};
												</span>
											</div>
										</div>
									</div>
									<div class="col-md-6 edit-supplier-data" v-if="editMode">
										<div class="row">
											<div class="col-md-4">
												<b>{{$t('supplierinfo.details.registration_code')}}</b>
											</div>
											<div class="col-md-6">
												<div class="form-group">
													<input
															v-model="supplier.registration_code"
															class="form-control"
															type="text"
															id="supplier_reg_code"
															:placeholder="$t('supplierinfo.details.registration_code')"
															autocomplete="off"
													>
												</div>
											</div>
										</div>
										<div class="row">
											<div class="col-md-4">
												<b>{{$t('supplierinfo.details.address')}}</b>
											</div>
											<div class="col-md-6">
												<div class="form-group">
													<input
															v-model="supplier.address"
															class="form-control"
															type="text"
															id="supplier_name"
															:placeholder="$t('supplierinfo.details.address')"
															autocomplete="off"
													>
												</div>
											</div>
										</div>
										<div class="row">
											<div class="col-md-4">
												<b>{{$t('supplierinfo.details.country')}}</b>
											</div>
											<div class="col-md-6">
												<div class="form-group">
													<select v-model="supplier.country_code"
															class="custom-select custom-select-md mb-3">
														<option disabled value="">{{ $t('register.select-country')}}
														</option>
														<option v-for="(country, idx) in countries" :key="idx"
																:value="country.code">
															{{country.name}}
														</option>
													</select>
													<ul class="parsley-errors-list filled"
														v-if="errors.company_country">
														<li class="parsley-required">{{ errors.company_country[0] }}
														</li>
													</ul>
												</div>
											</div>
										</div>
										<div class="row">
											<div class="col-md-4">
												<b>{{$t('supplierinfo.details.email')}}</b>
											</div>
											<div class="col-md-6">
												<div class="form-group">
													<input
															v-model="supplier.email"
															class="form-control"
															type="text"
															id="supplier_email"
															:placeholder="$t('supplierinfo.details.email')"
															autocomplete="off"
													>
												</div>
											</div>
										</div>
										<div class="row" v-if="editMode && is_administrator">
											<div class="col-md-4">
												<b>{{ $t('make.groups') }}</b>
											</div>
											<div class="col-md-6">
												<div class="form-group">
													<multiselect
															v-model="supplier.group"
															:tag-placeholder="$t('supplier.group-add-new')"
															:placeholder="$t('supplier.group-add-new')"
															label="name"
															track-by="name"
															:options="warehouse_groups"
															:multiple="true"
															:taggable="true"
															@tag="addGroup">

														<template slot="noOptions">{{ $t('global.no-options') }}
														</template>
													</multiselect>
													<ul class="parsley-errors-list filled" v-if="errors.groups">
														<li class="parsley-required">{{ $t('global.choose-group') }}
														</li>
													</ul>
												</div>
											</div>
										</div>


									</div>
									<div class="col-md-6 pull-right">
										<div class="row">
											<label class="col-form-labe col-md-12 pl-0"><b>{{ $t('register.notes')}}</b></label>
											<div class="notes col-lg-12 pl-0" v-if="editMode">
												<textarea rows="5" class="form-control note-editor"
														  :placeholder="$t('register.notes_placeholder')"
														  v-model="supplier.notes"
												>
												</textarea>
											</div>
											<div v-else>
												<div class="notes col-md-12 pl-0">
													{{supplier.notes}}
												</div>
											</div>
										</div>
										<div class="row" v-if="(is_advanced || is_administrator)">
											<label class="col-form-label">
												<b>{{ $t('supplierinfo.employees_can_view')}}</b>
											</label>
											<div class="checkbox c-checkbox"
                           :class="!editMode ? 'disable-drag disabled-drag' : ''"
												 style="margin-left:20px;margin-top:6px;">
												<label class="mb-0">
													<input
															type="checkbox"
															class="select-box"

															v-model="supplier.is_employees_can_view_proposal"
													>
													<span class="fa fa-check"> </span>
												</label>
											</div>
										</div>
									</div>
								</div>

							</div>
						</div>
					</div>
					<div class="card">
						<div class="card-body">
							<div class="card" role="tabpanel">
								<!-- Nav tabs-->
								<ul class="nav nav-tabs nav-tab-custom nav-fill" role="tablist">
									<li class="nav-item" role="presentation">
										<a class="nav-link active show" href="#users" aria-controls="users" role="tab"
										   data-toggle="tab" aria-selected="true">
											<em class="icon-people"></em> {{$t('supplierinfo.details.users')}}</a>
									</li>
									<li class="nav-item" role="presentation">
										<a class="nav-link" href="#categories" aria-controls="categories" role="tab"
										   data-toggle="tab" aria-selected="false">
											<em class="icon-folder-alt"></em>
											{{$t('supplierinfo.details.category')}}</a>
									</li>
									<li class="nav-item" role="presentation">
										<a class="nav-link" href="#notifications" aria-controls="notifications"
										   role="tab" data-toggle="tab" aria-selected="false">
											<em class="icon-envelope"></em> {{$t('supplierinfo.details.mark')}}</a>
									</li>
								</ul>
								<!-- Tab panes-->
								<div class="tab-content p-0">
									<div class="tab-pane active show tab-pad" id="users" role="tabpanel">
										<div class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer">
											<div class="row">
												<div class="col-md-6">
													<router-link
															:to="{name: 'supplier_users_add', params: {sup_id: supplier.id}}"
															:title="$t('profile.add-supplier-employee')"
															class="btn btn-outline-warning btn-sm">
														<i class="icon-plus"></i> {{ $t('profile.add-supplier-employee')
														}}
													</router-link>
												</div>
												<div class="col-md-6">
													<search @make_search="make_search"/>
												</div>
											</div>
											<table class="table table-striped dataTable my-4 w-100" id="supplier_users">
												<thead>
												<tr>
													<th
															:class="{
                          'sorting_asc': ordering === 'first_name',
                          'sorting_desc': ordering === '-first_name'}"
															@click="order('first_name')">{{
														$t('supplierusers.first-name') }}
													</th>
													<th
															:class="{
                          'sorting_asc': ordering === 'last_name',
                          'sorting_desc': ordering === '-last_name'}"
															@click="order('last_name')">{{ $t('supplierusers.last-name')
														}}
													</th>
													<th
															:class="{
                          'sorting_asc': ordering === 'email',
                          'sorting_desc': ordering === '-email'}"
															@click="order('email')">{{ $t('supplierusers.email') }}
													</th>
													<th
															:class="{
                          'sorting_asc': ordering === 'personal_code',
                          'sorting_desc': ordering === '-personal_code'}"
															@click="order('personal_code')">{{
														$t('supplierusers.personal-code') }}
													</th>
													<th
															:class="{
                          'sorting_asc': ordering === 'phone',
                          'sorting_desc': ordering === '-phone'}"
															@click="order('phone')">{{ $t('supplierusers.phone') }}
													</th>
													<th
															:class="{
                          'sorting_asc': ordering === 'position',
                          'sorting_desc': ordering === '-position'}"
															@click="order('position')">{{ $t('supplierusers.position')
														}}
													</th>
													<th>{{ $t('supplieruser.role') }}</th>
													<th
															:class="{
                          'sorting_asc': ordering === 'is_active',
                          'sorting_desc': ordering === '-is_active'}"
															@click="order('is_active')">{{ $t('supplierusers.status') }}
													</th>
                          <th v-if="!is_supplier">{{ $t('supplierusers.terms-accepted') }}</th>
													<th
															:class="{
                          'sorting_asc': ordering === 'last_login',
                          'sorting_desc': ordering === '-last_login'}"
															@click="order('last_login')">{{
														$t('supplierusers.last-login') }}
													</th>
												</tr>
												</thead>
												<tbody>
												<tr :key="row.id" class="gradeX" v-for="(row, index) in rows">
													<td>{{ row.first_name }}</td>
													<td>{{ row.last_name }}</td>
													<td>{{ row.email }}</td>
													<td>{{ row.personal_code }}</td>
													<td>{{ row.phone }}</td>
													<td>{{ row.position }}</td>
													<td>
														<span v-if="row.role == 'PLAIN'">
															{{ $t('supplierinfo.plain') }}
														</span>
														<span v-if="row.role == 'ADVANCED'">
															{{$t('supplierinfo.advanced') }}
														</span>
													</td>
													<td>{{ row.is_active ? 'Active': 'Disabled' }}</td>
                          <td v-if="!is_supplier">{{ row.terms_accepted | formatDateTime }}</td>
													<td>{{ row.last_login | formatDateTime }}</td>
													<td v-if="editMode">
														<router-link
																:to="{name: 'supplier_users_edit', params: {sup_id: supplier.id, id: row.id}}"
																class="far fa-edit"
														/>
														<button
																v-if="!is_supplier"
																class="btn btn-link pl-1 pt-1"
																:title="$t('workers.button-delete')"
																@click="remove_account(row.id, index)">
															<i class="far fa-trash-alt"></i>
														</button>
													</td>
												</tr>
												</tbody>
											</table>
											<pagination
													:page="page"
													:pages="pages"
													:count="count"
													:from="(page - 1) * 30 + 1"
													:to="(page - 1) * 30 + rows.length"
													@paginate="paginate"
											/>
										</div>

									</div>

									<div class="tab-pane tab-pad" id="categories" role="tabpanel">
										<!-- Group selection -->
										<div class="row p-t-30">
											<div class="col-md-2" v-for="(group, idx) in groups" :key="'group-'+idx">

												<div class="checkbox c-checkbox">
													<label class="mb-0">
														<input
																type="checkbox"
																class="select-box"
																:checked="selectedDivision == group.id"
																@click="switchGroup(group.id)"
														>

														<span class="fa fa-check"> </span>
														{{group.name}}
													</label>

												</div>
											</div>
										</div>

										<div class="dd" id="nestable" v-if="listItems.length > 0 &&
										this.groups.length>0">
											<div
                        class="nestable-container"
                        :class="{'disable-drag disabled-drag': !editMode || !is_administrator}"
											>
												<!-- Supplier categories -->
												<VueNestable
														v-model="listItems"
														:max-depth="5"
														key-prop="key"
														children-prop="nested"
														class-prop="class"
														cross-list
														group="cross"
												>
													<template slot-scope="{ item }">
														<div class="nestable-item ">
															<div class="row nest-row nest-only-check"
																 :class="item.type == 'productclass' ? 'red' : ''"
																 data-collapse="open">
																<div class="checkbox c-checkbox">
																	<a href="#" class="nest-collapser"
																	   v-if="item.nested.length>0">
																		<i class="icon-arrow-down collapser-icon"></i>
																	</a>
																	<label class="mb-0">
																		<input
																				type="checkbox"
																				@click="onCheckboxClick(item)"
																				class="select-box"
																				:checked="item.checked ? '1' : '0'"
																				v-model="item.checked"
																		>
																		<span class="fa fa-check"> </span>
																	</label>
																	{{item.text}}
																</div>
																<VueNestableHandle :item="item"
																				   class="disabled-drag"></VueNestableHandle>
															</div>
														</div>
													</template>
												</VueNestable>
											</div>
										</div>
									</div>
									<div class="tab-pane tab-pad" id="notifications" role="tabpanel">
                      <h3 class="my-3">{{ $t('supplierinfo.deprecated') }}</h3>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- End of Content -->
		</div>
	</section>
</template>

<script>
	import api from '@/api'
	import Buttons from '@/components/Buttons.vue'
	import message from '@/message'
	import More from '@/components/More.vue'
	import Multiselect from 'vue-multiselect'
	import Contentheading from '@/components/Contentheading.vue'
	import Pagination from '@/components/Pagination.vue'
	import Search from '@/components/Search.vue'

	const getData = (id, route, next) => {
		const search = route.query.search
		const ordering = route.query.ordering || 'id'
		const page = parseInt(route.query.page) || 1
		let selectedDivision = localStorage.selectedDivision;

		Promise.all([
			api.get(`/suppliers/${id}/`),
			api.get(`/groups/?page_size=100`),
			api.get(`/categories/tree/` + selectedDivision + '/'),
			api.get('/supplier_users/', {
				params: {
					search: search,
					ordering: ordering,
					page: page,
					supplier: id
				}
			}),
			api.get('/supplier_category_groups/?page_size=200', {
				params: {
					supplier: id,
					group: localStorage.selectedDivision
				}
			})
		])
			.then(([supplier, groups, treeList, users, selectedCategories]) => {

				if (supplier.data.is_new) {
					api.patch('/suppliers/' + supplier.data.id + '/', { // OK
						name: supplier.data.name,
						registration_code: supplier.data.registration_code,
						email: supplier.data.email,
						is_new: false,
					});
				}
				let list = [];
				let categories = [];
				let rowIndex = 0;
				let previouslyCheckedCategories = [];
				let categoryRowIndex = 0;

				let categoryGroupReg = [];
				let supplierCategoryGroups = [];

				//Supplier groups
				let group = []
				let groupsRegister = [];
				groups.data.results.forEach(g => {
					groupsRegister[g.name] = g.id;
				})

				let supplierGroup = supplier.data.warehouse_group;
				if (supplier.data.warehouse_groups) {
					supplier.data.warehouse_groups.forEach(wg => {
						group.push({
							'id': groupsRegister[wg],
							'name': wg
						})
					})
				}
				supplier.data.group = group

				// Selected categories
				selectedCategories.data.results.forEach(r => {
					categoryGroupReg.push({id: r.id, category: r.category})
					supplierCategoryGroups.push(r.category);
				})


				// Supplier checked categories
				supplier.data.categories.forEach(r => {
					let selectedRow = {
						key: categoryRowIndex,
						class: 'purple-text-color',
						text: r,
						type: 'row',
						code: '',
						checked: true,
					}

					previouslyCheckedCategories.push(selectedRow);
					categoryRowIndex++;
				})

				// check if supplier really has the selecteddivision
				/*let allowTreeView = false;
				supplier.data.group.forEach(supplierGroup => {
					if(supplierGroup.id == localStorage.selectedDivision){
						allowTreeView = true;
					}
				})*/

				// Category tree
				treeList.data.tree.list.forEach(r => {
					let childRows = [];
					// First dimension
					r.nested.forEach(child => {
						let secondChildList = [];

						// Second dimension
						if (child.nested.length > 0) {
							child.nested.forEach(secondChild => {
								// Third last dimension
								let thirdChildList = [];
								secondChild.nested.forEach(thirdChild => {
									let tempThirdChild = {
										key: thirdChild.key,
										class: 'purple-text-color',
										text: thirdChild.text,
										productClass: thirdChild.class,
										type: 'category',
										collapsed: false,
										nested: thirdChild.nested,
										visible: true,
										card: 'tree',
										checked: (supplierCategoryGroups.includes(thirdChild.key)) ? true : false,
									};
									thirdChildList.push(tempThirdChild);
								});

								let secondTempChild = {
									key: secondChild.key,
									class: 'purple-text-color',
									text: secondChild.text,
									productClass: secondChild.class,
									type: 'category',
									collapsed: false,
									nested: thirdChildList,
									visible: true,
									card: 'tree',
									checked: (supplierCategoryGroups.includes(secondChild.key)) ? true : false,
								};
								secondChildList.push(secondTempChild);
							});
						}

						let childRow = {
							key: child.key,
							class: 'purple-text-color',
							text: child.text,
							productClass: child.class,
							type: 'category',
							collapsed: false,
							nested: secondChildList,
							visible: true,
							card: 'tree',
							checked: (supplierCategoryGroups.includes(child.key)) ? true : false,
						};
						childRows.push(childRow);
					});
					let rowData = {
						key: r.key,
						class: 'purple-text-color',
						text: r.text,
						productClass: r.class,
						type: 'category',
						collapsed: false,
						nested: childRows,
						visible: true,
						card: 'tree',
						checked: (supplierCategoryGroups.includes(r.key)) ? true : false,
					};
					list.push(rowData);
				})

				next({
					listItems: list,
					temporaryCategories: previouslyCheckedCategories,
					previouslySelectedCategories: previouslyCheckedCategories,
					selectedCategories: previouslyCheckedCategories,
					categoryGroupReg: categoryGroupReg,
					supplierCategoryGroups: supplierCategoryGroups,
					rows: users.data.results,
					search: search,
					ordering: ordering,
					pages: users.data.pages,
					count: users.data.count,
					page: page,
					supplier: supplier.data,
					warehouse_group: group,
					warehouse_groups: groups.data.results,
					groups: group,
				})
			})
	}
	export default {
		components: {
			buttons: Buttons,
			more: More,
			Multiselect,
			contentheading: Contentheading,
			pagination: Pagination,
			search: Search
		},
		data() {
			return {
				allowTreeView:false,
				previouslySelectedCategories: [],
				temporaryCategories: [],
				categoryGroupReg: [],
				is_advanced: false,
				supplierCategoryGroups: [],
				selectedCategories: [],
				selectedDivision: 1,
				groups: [],
				rows: [],
				supplier_user: {},
				editMode: false,
				warehouse_group: [],
				warehouse_groups: [],
				more: null,
				errors: {},
				supplier: {},
				search: null,
				ordering: null,
				pages: null,
				count: null,
				page: null,
				listItems: [
					{
						key: 0,
						class: 'purple-text-color',
						text: 'Item 1',
						type: 'row',
						code: '12002',
						checked: false,
						nested: []
					},
					{
						key: 1,
						class: 'blue-text-color',
						text: 'Item 2',
						checked: true,
						nested: [
							{
								key: 2,
								text: 'Item 2.5',
								type: 'row',
								code: '12002.5',
								checked: true,
								nested: []
							}
						],
						type: 'row',
						code: '12003'
					},
					{
						key: 3,
						class: 'red-text-color',
						text: 'Item 3',
						type: 'row',
						code: '12004',
						checked: false,
						nested: []
					},
					{
						key: 4,
						text: 'Item 4',
						type: 'row',
						code: '12005',
						checked: true,
						nested: []
					}
				],
				editButton: {
					label: this.$i18n.t('supplierinfo.edit-supplier'),
					class: 'btn-warning'
				},
				countries: [
					{name: 'Afghanistan', code: 'AF'},
					{name: 'Åland Islands', code: 'AX'},
					{name: 'Albania', code: 'AL'},
					{name: 'Algeria', code: 'DZ'},
					{name: 'American Samoa', code: 'AS'},
					{name: 'AndorrA', code: 'AD'},
					{name: 'Angola', code: 'AO'},
					{name: 'Anguilla', code: 'AI'},
					{name: 'Antarctica', code: 'AQ'},
					{name: 'Antigua and Barbuda', code: 'AG'},
					{name: 'Argentina', code: 'AR'},
					{name: 'Armenia', code: 'AM'},
					{name: 'Aruba', code: 'AW'},
					{name: 'Australia', code: 'AU'},
					{name: 'Austria', code: 'AT'},
					{name: 'Azerbaijan', code: 'AZ'},
					{name: 'Bahamas', code: 'BS'},
					{name: 'Bahrain', code: 'BH'},
					{name: 'Bangladesh', code: 'BD'},
					{name: 'Barbados', code: 'BB'},
					{name: 'Belarus', code: 'BY'},
					{name: 'Belgium', code: 'BE'},
					{name: 'Belize', code: 'BZ'},
					{name: 'Benin', code: 'BJ'},
					{name: 'Bermuda', code: 'BM'},
					{name: 'Bhutan', code: 'BT'},
					{name: 'Bolivia', code: 'BO'},
					{name: 'Bosnia and Herzegovina', code: 'BA'},
					{name: 'Botswana', code: 'BW'},
					{name: 'Bouvet Island', code: 'BV'},
					{name: 'Brazil', code: 'BR'},
					{name: 'British Indian Ocean Territory', code: 'IO'},
					{name: 'Brunei Darussalam', code: 'BN'},
					{name: 'Bulgaria', code: 'BG'},
					{name: 'Burkina Faso', code: 'BF'},
					{name: 'Burundi', code: 'BI'},
					{name: 'Cambodia', code: 'KH'},
					{name: 'Cameroon', code: 'CM'},
					{name: 'Canada', code: 'CA'},
					{name: 'Cape Verde', code: 'CV'},
					{name: 'Cayman Islands', code: 'KY'},
					{name: 'Central African Republic', code: 'CF'},
					{name: 'Chad', code: 'TD'},
					{name: 'Chile', code: 'CL'},
					{name: 'China', code: 'CN'},
					{name: 'Christmas Island', code: 'CX'},
					{name: 'Cocos (Keeling) Islands', code: 'CC'},
					{name: 'Colombia', code: 'CO'},
					{name: 'Comoros', code: 'KM'},
					{name: 'Congo', code: 'CG'},
					{name: 'Congo, The Democratic Republic of the', code: 'CD'},
					{name: 'Cook Islands', code: 'CK'},
					{name: 'Costa Rica', code: 'CR'},
					{name: 'Cote D\'Ivoire', code: 'CI'},
					{name: 'Croatia', code: 'HR'},
					{name: 'Cuba', code: 'CU'},
					{name: 'Cyprus', code: 'CY'},
					{name: 'Czech Republic', code: 'CZ'},
					{name: 'Denmark', code: 'DK'},
					{name: 'Djibouti', code: 'DJ'},
					{name: 'Dominica', code: 'DM'},
					{name: 'Dominican Republic', code: 'DO'},
					{name: 'Ecuador', code: 'EC'},
					{name: 'Egypt', code: 'EG'},
					{name: 'El Salvador', code: 'SV'},
					{name: 'Equatorial Guinea', code: 'GQ'},
					{name: 'Eritrea', code: 'ER'},
					{name: 'Estonia', code: 'EE'},
					{name: 'Ethiopia', code: 'ET'},
					{name: 'Falkland Islands (Malvinas)', code: 'FK'},
					{name: 'Faroe Islands', code: 'FO'},
					{name: 'Fiji', code: 'FJ'},
					{name: 'Finland', code: 'FI'},
					{name: 'France', code: 'FR'},
					{name: 'French Guiana', code: 'GF'},
					{name: 'French Polynesia', code: 'PF'},
					{name: 'French Southern Territories', code: 'TF'},
					{name: 'Gabon', code: 'GA'},
					{name: 'Gambia', code: 'GM'},
					{name: 'Georgia', code: 'GE'},
					{name: 'Germany', code: 'DE'},
					{name: 'Ghana', code: 'GH'},
					{name: 'Gibraltar', code: 'GI'},
					{name: 'Greece', code: 'GR'},
					{name: 'Greenland', code: 'GL'},
					{name: 'Grenada', code: 'GD'},
					{name: 'Guadeloupe', code: 'GP'},
					{name: 'Guam', code: 'GU'},
					{name: 'Guatemala', code: 'GT'},
					{name: 'Guernsey', code: 'GG'},
					{name: 'Guinea', code: 'GN'},
					{name: 'Guinea-Bissau', code: 'GW'},
					{name: 'Guyana', code: 'GY'},
					{name: 'Haiti', code: 'HT'},
					{name: 'Heard Island and Mcdonald Islands', code: 'HM'},
					{name: 'Holy See (Vatican City State)', code: 'VA'},
					{name: 'Honduras', code: 'HN'},
					{name: 'Hong Kong', code: 'HK'},
					{name: 'Hungary', code: 'HU'},
					{name: 'Iceland', code: 'IS'},
					{name: 'India', code: 'IN'},
					{name: 'Indonesia', code: 'ID'},
					{name: 'Iran, Islamic Republic Of', code: 'IR'},
					{name: 'Iraq', code: 'IQ'},
					{name: 'Ireland', code: 'IE'},
					{name: 'Isle of Man', code: 'IM'},
					{name: 'Israel', code: 'IL'},
					{name: 'Italy', code: 'IT'},
					{name: 'Jamaica', code: 'JM'},
					{name: 'Japan', code: 'JP'},
					{name: 'Jersey', code: 'JE'},
					{name: 'Jordan', code: 'JO'},
					{name: 'Kazakhstan', code: 'KZ'},
					{name: 'Kenya', code: 'KE'},
					{name: 'Kiribati', code: 'KI'},
					{name: 'Korea, Democratic People\'S Republic of', code: 'KP'},
					{name: 'Korea, Republic of', code: 'KR'},
					{name: 'Kuwait', code: 'KW'},
					{name: 'Kyrgyzstan', code: 'KG'},
					{name: 'Lao People\'S Democratic Republic', code: 'LA'},
					{name: 'Latvia', code: 'LV'},
					{name: 'Lebanon', code: 'LB'},
					{name: 'Lesotho', code: 'LS'},
					{name: 'Liberia', code: 'LR'},
					{name: 'Libyan Arab Jamahiriya', code: 'LY'},
					{name: 'Liechtenstein', code: 'LI'},
					{name: 'Lithuania', code: 'LT'},
					{name: 'Luxembourg', code: 'LU'},
					{name: 'Macao', code: 'MO'},
					{name: 'Macedonia, The Former Yugoslav Republic of', code: 'MK'},
					{name: 'Madagascar', code: 'MG'},
					{name: 'Malawi', code: 'MW'},
					{name: 'Malaysia', code: 'MY'},
					{name: 'Maldives', code: 'MV'},
					{name: 'Mali', code: 'ML'},
					{name: 'Malta', code: 'MT'},
					{name: 'Marshall Islands', code: 'MH'},
					{name: 'Martinique', code: 'MQ'},
					{name: 'Mauritania', code: 'MR'},
					{name: 'Mauritius', code: 'MU'},
					{name: 'Mayotte', code: 'YT'},
					{name: 'Mexico', code: 'MX'},
					{name: 'Micronesia, Federated States of', code: 'FM'},
					{name: 'Moldova, Republic of', code: 'MD'},
					{name: 'Monaco', code: 'MC'},
					{name: 'Mongolia', code: 'MN'},
					{name: 'Montserrat', code: 'MS'},
					{name: 'Morocco', code: 'MA'},
					{name: 'Mozambique', code: 'MZ'},
					{name: 'Myanmar', code: 'MM'},
					{name: 'Namibia', code: 'NA'},
					{name: 'Nauru', code: 'NR'},
					{name: 'Nepal', code: 'NP'},
					{name: 'Netherlands', code: 'NL'},
					{name: 'Netherlands Antilles', code: 'AN'},
					{name: 'New Caledonia', code: 'NC'},
					{name: 'New Zealand', code: 'NZ'},
					{name: 'Nicaragua', code: 'NI'},
					{name: 'Niger', code: 'NE'},
					{name: 'Nigeria', code: 'NG'},
					{name: 'Niue', code: 'NU'},
					{name: 'Norfolk Island', code: 'NF'},
					{name: 'Northern Mariana Islands', code: 'MP'},
					{name: 'Norway', code: 'NO'},
					{name: 'Oman', code: 'OM'},
					{name: 'Pakistan', code: 'PK'},
					{name: 'Palau', code: 'PW'},
					{name: 'Palestinian Territory, Occupied', code: 'PS'},
					{name: 'Panama', code: 'PA'},
					{name: 'Papua New Guinea', code: 'PG'},
					{name: 'Paraguay', code: 'PY'},
					{name: 'Peru', code: 'PE'},
					{name: 'Philippines', code: 'PH'},
					{name: 'Pitcairn', code: 'PN'},
					{name: 'Poland', code: 'PL'},
					{name: 'Portugal', code: 'PT'},
					{name: 'Puerto Rico', code: 'PR'},
					{name: 'Qatar', code: 'QA'},
					{name: 'Reunion', code: 'RE'},
					{name: 'Romania', code: 'RO'},
					{name: 'Russian Federation', code: 'RU'},
					{name: 'RWANDA', code: 'RW'},
					{name: 'Saint Helena', code: 'SH'},
					{name: 'Saint Kitts and Nevis', code: 'KN'},
					{name: 'Saint Lucia', code: 'LC'},
					{name: 'Saint Pierre and Miquelon', code: 'PM'},
					{name: 'Saint Vincent and the Grenadines', code: 'VC'},
					{name: 'Samoa', code: 'WS'},
					{name: 'San Marino', code: 'SM'},
					{name: 'Sao Tome and Principe', code: 'ST'},
					{name: 'Saudi Arabia', code: 'SA'},
					{name: 'Senegal', code: 'SN'},
					{name: 'Serbia and Montenegro', code: 'CS'},
					{name: 'Seychelles', code: 'SC'},
					{name: 'Sierra Leone', code: 'SL'},
					{name: 'Singapore', code: 'SG'},
					{name: 'Slovakia', code: 'SK'},
					{name: 'Slovenia', code: 'SI'},
					{name: 'Solomon Islands', code: 'SB'},
					{name: 'Somalia', code: 'SO'},
					{name: 'South Africa', code: 'ZA'},
					{name: 'South Georgia and the South Sandwich Islands', code: 'GS'},
					{name: 'Spain', code: 'ES'},
					{name: 'Sri Lanka', code: 'LK'},
					{name: 'Sudan', code: 'SD'},
					{name: 'Suriname', code: 'SR'},
					{name: 'Svalbard and Jan Mayen', code: 'SJ'},
					{name: 'Swaziland', code: 'SZ'},
					{name: 'Sweden', code: 'SE'},
					{name: 'Switzerland', code: 'CH'},
					{name: 'Syrian Arab Republic', code: 'SY'},
					{name: 'Taiwan, Province of China', code: 'TW'},
					{name: 'Tajikistan', code: 'TJ'},
					{name: 'Tanzania, United Republic of', code: 'TZ'},
					{name: 'Thailand', code: 'TH'},
					{name: 'Timor-Leste', code: 'TL'},
					{name: 'Togo', code: 'TG'},
					{name: 'Tokelau', code: 'TK'},
					{name: 'Tonga', code: 'TO'},
					{name: 'Trinidad and Tobago', code: 'TT'},
					{name: 'Tunisia', code: 'TN'},
					{name: 'Turkey', code: 'TR'},
					{name: 'Turkmenistan', code: 'TM'},
					{name: 'Turks and Caicos Islands', code: 'TC'},
					{name: 'Tuvalu', code: 'TV'},
					{name: 'Uganda', code: 'UG'},
					{name: 'Ukraine', code: 'UA'},
					{name: 'United Arab Emirates', code: 'AE'},
					{name: 'United Kingdom', code: 'GB'},
					{name: 'United States', code: 'US'},
					{name: 'United States Minor Outlying Islands', code: 'UM'},
					{name: 'Uruguay', code: 'UY'},
					{name: 'Uzbekistan', code: 'UZ'},
					{name: 'Vanuatu', code: 'VU'},
					{name: 'Venezuela', code: 'VE'},
					{name: 'Viet Nam', code: 'VN'},
					{name: 'Virgin Islands, British', code: 'VG'},
					{name: 'Virgin Islands, U.S.', code: 'VI'},
					{name: 'Wallis and Futuna', code: 'WF'},
					{name: 'Western Sahara', code: 'EH'},
					{name: 'Yemen', code: 'YE'},
					{name: 'Zambia', code: 'ZM'},
					{name: 'Zimbabwe', code: 'ZW'}
				],
			}
		},
		created() {
			Promise.all([
				api.get('/profile/')
			]).then(([supplierData]) => {
				if (supplierData.data.results[0].role.match('ADVANCED')) {
					this.is_advanced = true;
				}
			}).catch(error => {
				sessionStorage.removeItem('previous_route');
			})
		},
		computed: {

			is_supplier() {
				return this.$store.getters.user_group === 'Supplier'
			},
			is_administrator() {
				return this.$store.getters.user_group === 'Administrator'
			},
			is_contractor() {
				return this.$store.getters.user_group === 'Contractor'
			},
			canCheckEmployee() {
				if (!this.editMode) {
					return true;
				} else {
					return this.is_advanced || this.is_administrator;
				}
			}
		},
		watch: {
			selectedDivision(newVal) {
				localStorage.selectedDivision = newVal;
			}
		},
		mounted() {
			this.$parent.menu = 'setup'
			this.$parent.submenu = 'suppliers'
			this.$i18n.locale = this.$store.getters.language

			if (localStorage.selectedDivision) {
				this.selectedDivision = localStorage.selectedDivision;
			}

		},
		methods: {
			addGroup(newName) {
				this.warehouse_group.push({
					name: newName
				})
			},
			switchGroup(groupId) {
				this.selectedDivision = groupId;
				localStorage.selectedDivision = groupId;
				let supplierId = this.$route.params.sup_id;
				this.categoryGroupReg = [];
				let categoryGroupReg = [];
				let supplierCategoryGroups = [];

				Promise.all([
					api.get(`/suppliers/${supplierId}/`),
					api.get(`/groups/?page_size=100`),
					api.get(`/categories/tree/` + this.selectedDivision + '/'),
					api.get('/supplier_category_groups/?page_size=200', {
						params: {
							supplier: this.$route.params.sup_id,
							group: localStorage.selectedDivision
						}
					})

				])
					.then(([supplier, groups, treeList, selectedCategories]) => {
						let list = [];
						let categories = [];
						let rowIndex = 0;
						let previouslyCheckedCategories = [];
						let categoryRowIndex = 0;
						// Selected categories
						selectedCategories.data.results.forEach(r => {
							categoryGroupReg.push({id: r.id, category: r.category})
							supplierCategoryGroups.push(r.category);
						})


						// Supplier checked categories
						supplier.data.categories.forEach(r => {
							let selectedRow = {
								key: categoryRowIndex,
								class: 'purple-text-color',
								text: r,
								type: 'row',
								code: '',
								checked: true,
							}

							previouslyCheckedCategories.push(selectedRow);
							categoryRowIndex++;
						})

						treeList.data.tree.list.forEach(r => {
							let childRows = [];
							// First dimension
							r.nested.forEach(child => {
								let secondChildList = [];

								// Second dimension
								if (child.nested.length > 0) {
									child.nested.forEach(secondChild => {
										// Third last dimension
										let thirdChildList = [];
										secondChild.nested.forEach(thirdChild => {
											let tempThirdChild = {
												key: thirdChild.key,
												class: 'purple-text-color',
												text: thirdChild.text,
												productClass: thirdChild.class,
												type: 'category',
												collapsed: false,
												nested: thirdChild.nested,
												visible: true,
												card: 'tree',
												checked: (supplierCategoryGroups.includes(thirdChild.key)) ? true : false,
											};
											thirdChildList.push(tempThirdChild);
										});

										let secondTempChild = {
											key: secondChild.key,
											class: 'purple-text-color',
											text: secondChild.text,
											productClass: secondChild.class,
											type: 'category',
											collapsed: false,
											nested: thirdChildList,
											visible: true,
											card: 'tree',
											checked: (supplierCategoryGroups.includes(secondChild.key)) ? true : false,
										};
										secondChildList.push(secondTempChild);
									});
								}

								let childRow = {
									key: child.key,
									class: 'purple-text-color',
									text: child.text,
									productClass: child.class,
									type: 'category',
									collapsed: false,
									nested: secondChildList,
									visible: true,
									card: 'tree',
									checked: (supplierCategoryGroups.includes(child.key)) ? true : false,
								};
								childRows.push(childRow);
							});
							let rowData = {
								key: r.key,
								class: 'purple-text-color',
								text: r.text,
								productClass: r.class,
								type: 'category',
								collapsed: false,
								nested: childRows,
								visible: true,
								card: 'tree',
								checked: (supplierCategoryGroups.includes(r.key)) ? true : false,
							};
							list.push(rowData);
						})

						this.listItems = list;
						this.selectedCategories = previouslyCheckedCategories;
						this.temporaryCategories = previouslyCheckedCategories;
						this.previouslySelectedCategories = previouslyCheckedCategories;
						this.categoryGroupReg = categoryGroupReg;
					})
			},
			cancelEdit() {
				this.editMode = false;
				this.editButton.label = this.$i18n.t('supplierinfo.edit-supplier');
				this.editButton.class = 'btn-warning';
				this.temporaryCategories = this.previouslySelectedCategories;
			},
			onCategoryCheck(item) {
				if (!this.editMode)
					return false;

			},
			checkCategory(item) {
				if (!this.editMode)
					return false;

				if (this.editMode) {
					for (let index = 0; index < this.listItems.length; index++) {
						const element = this.listItems[index];

						if (item.key == this.listItems[index].key) {
							this.listItems[index].checked = (this.listItems[index].checked) ? false : true;
						}
					}

				}

			},
			// Checks and detects if parent is clicked, check its childs
			onCheckboxClick(item) {
				if (item.checked == true) {
					// Delete from api
          const deletableKeys = this.categoryGroupReg.filter(r => r.category === item.key)

          deletableKeys.forEach(r => {
            api.delete('/supplier_category_groups/' + r.id + '/')
              .then(() => {
                const index = this.categoryGroupReg.findIndex(i => i.id === r.id)
                if (index > -1) this.categoryGroupReg.splice(index, 1)
              })
          })
				}

				if (item.checked == false) {
					// Check current
					this.temporaryCategories.push(item);
					api.post('/supplier_category_groups/', {
						supplier: this.$route.params.sup_id,
						group: localStorage.selectedDivision,
						category: item.key
					}).then(response => {
            this.categoryGroupReg.push({
              id: response.data.id,
              category: response.data.category
            });
					});

					// Check children when parent is checked
					// if (item.nested.length > 0) {
					// 	for (let index = 0; index < this.listItems.length; index++) {
					// 		const element = this.listItems[index];
					// 		if (element.key == item.key) {
					// 			for (let childIndex = 0; childIndex < this.listItems[index].nested.length; childIndex++) {
					// 				this.listItems[index].nested[childIndex].checked = true;
					// 				// Set children to selected categories
					// 				this.temporaryCategories.push(this.listItems[index].nested[childIndex]);
					// 				api.post('/supplier_category_groups/', {
					// 					supplier: this.$route.params.sup_id,
					// 					group: localStorage.selectedDivision,
					// 					category: this.listItems[index].nested[childIndex].key
					// 				}).then(response => {
					// 					this.categoryGroupReg.push({
					// 						id: response.data.id,
					// 						category: response.data.category
					// 					});
					// 				});
					// 			}
					// 		}
					// 	}
					// }
				} else {
					for (let i = 0; i < this.temporaryCategories.length; i++) {
						if (this.temporaryCategories[i].text == item.text) {
							this.temporaryCategories.splice(i, 1);
						}
					}
				}
				this.updateCategories();
			},
			reloadTree(){
				let supplierId = this.$route.params.sup_id;
				let categoryGroupReg = [];
				let supplierCategoryGroups = [];

				Promise.all([
					api.get(`/suppliers/${supplierId}/`),
					api.get(`/groups/?page_size=100`),
					api.get(`/categories/tree/` + this.selectedDivision + '/'),
					api.get('/supplier_category_groups/?page_size=200', {
						params: {
							supplier: this.$route.params.sup_id,
							group: localStorage.selectedDivision
						}
					})

				])
					.then(([supplier, groups, treeList, selectedCategories]) => {
						let list = [];
						let categories = [];
						let rowIndex = 0;
						let previouslyCheckedCategories = [];
						let categoryRowIndex = 0;
						// Selected categories
						selectedCategories.data.results.forEach(r => {
							categoryGroupReg.push({id: r.id, category: r.category})
							supplierCategoryGroups.push(r.category);
						})


						// Supplier checked categories
						supplier.data.categories.forEach(r => {
							let selectedRow = {
								key: categoryRowIndex,
								class: 'purple-text-color',
								text: r,
								type: 'row',
								code: '',
								checked: true,
							}

							previouslyCheckedCategories.push(selectedRow);
							categoryRowIndex++;
						})

						treeList.data.tree.list.forEach(r => {
							let childRows = [];
							// First dimension
							r.nested.forEach(child => {
								let secondChildList = [];

								// Second dimension
								if (child.nested.length > 0) {
									child.nested.forEach(secondChild => {
										// Third last dimension
										let thirdChildList = [];
										secondChild.nested.forEach(thirdChild => {
											let tempThirdChild = {
												key: thirdChild.key,
												class: 'purple-text-color',
												text: thirdChild.text,
												productClass: thirdChild.class,
												type: 'category',
												collapsed: false,
												nested: thirdChild.nested,
												visible: true,
												card: 'tree',
												checked: (supplierCategoryGroups.includes(thirdChild.key)) ? true : false,
											};
											thirdChildList.push(tempThirdChild);
										});

										let secondTempChild = {
											key: secondChild.key,
											class: 'purple-text-color',
											text: secondChild.text,
											productClass: secondChild.class,
											type: 'category',
											collapsed: false,
											nested: thirdChildList,
											visible: true,
											card: 'tree',
											checked: (supplierCategoryGroups.includes(secondChild.key)) ? true : false,
										};
										secondChildList.push(secondTempChild);
									});
								}

								let childRow = {
									key: child.key,
									class: 'purple-text-color',
									text: child.text,
									productClass: child.class,
									type: 'category',
									collapsed: false,
									nested: secondChildList,
									visible: true,
									card: 'tree',
									checked: (supplierCategoryGroups.includes(child.key)) ? true : false,
								};
								childRows.push(childRow);
							});
							let rowData = {
								key: r.key,
								class: 'purple-text-color',
								text: r.text,
								productClass: r.class,
								type: 'category',
								collapsed: false,
								nested: childRows,
								visible: true,
								card: 'tree',
								checked: (supplierCategoryGroups.includes(r.key)) ? true : false,
							};
							list.push(rowData);
						})

						this.listItems = list;
						this.selectedCategories = previouslyCheckedCategories;
						this.temporaryCategories = previouslyCheckedCategories;
						this.previouslySelectedCategories = previouslyCheckedCategories;

					})
			},
			reloadGroups(groups){
				this.groups = this.supplier.group;
				let nextSet = false
				this.supplier.group.forEach(sG =>{
					if(!nextSet){
						this.switchGroup(sG.id);
						nextSet = true;
					}
				})
			},
			toggleEditMode() {
				this.editMode = (this.editMode) ? false : true;

				if (this.editMode) {
					this.editButton.label = this.$i18n.t('supplierinfo.confirm-changes');
					this.editButton.class = 'btn-success';
				} else {
					this.editButton.label = this.$i18n.t('supplierinfo.edit-supplier');
					this.editButton.class = 'btn-warning';
					this.confirmChanges();

					let supplierGroups = [];
					this.supplier.group.forEach(sG => {
						supplierGroups.push(sG.name);
					})

					api.patch('/suppliers/' + this.supplier.id + '/', { // OK0,
						name: this.supplier.name,
						registration_code: this.supplier.registration_code,
						email: this.supplier.email,
						address: this.supplier.address,
						is_new: false,
						is_employees_can_view_proposal: this.supplier.is_employees_can_view_proposal,
						notes: this.supplier.notes,
						warehouse_groups: supplierGroups,
						category_update_ts: new Date()
					}).then(response => {
						this.reloadTree();
						this.reloadGroups(supplierGroups);
					});
				}
			},
			updateCategories() {
				let categoryNames = [];

				for (let i = 0; i < this.selectedCategories.length; i++) {
					categoryNames.push(this.selectedCategories[i].text);
				}

				api.patch('/suppliers/' + this.supplier.id + '/', {
					categories: categoryNames,
					category_update_ts: new Date()
				});
			},
			confirmChanges() {
				//TODO: Fetch category checklist && notifcation checks and send them to backend
			},
			remove_account(id, index) {
				this.$swal({
					type: 'warning',
					title: this.$i18n.t('supplierusers.are-you-sure'),
					text: this.$i18n.t('supplierusers.are-you-sure-text-cancel'),
					showCancelButton: true
				})
					.then((choice) => {
						if (choice.value) {
							api.post('/remove_account/', {
								user_id: id
							})
								.then(() => {
									message.success(this.$i18n.t('supplierusers.account-deleted'))
									this.$delete(this.rows, index)
								})
								.catch(() => {
									message.error(this.$i18n.t('supplierusers.forbidden'))
								})
						}
					})
			},
			order(o) {
				this.$parent.order(o, this.search, this.ordering)
			},
			paginate(p) {
				this.$parent.paginate(p, this.search, this.ordering)
			},
			make_search() {
				this.$parent.make_search(this.search, this.ordering)
			}
		},
		beforeRouteEnter(to, from, next) {
			getData(to.params.sup_id, to, data => {
				next(vm => {
					Object.assign(vm.$data, data)
				})
			})
		},
		beforeRouteUpdate(to, from, next) {
			getData(to.params.sup_id, to, data => {
				Object.assign(this.$data, data)
				next()
			})
		}
	}
</script>



// WEBPACK FOOTER //
// src/views/SupplierInfo.vue